import { Fetch, schemas } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';

export function logout(fetch: Fetch) {
  return fetch(
    '/auth/logout',
    {
      method: 'POST'
    },
    schemas.LoginResponse
  );
}

export function useLogoutMutation(fetch: Fetch) {
  return useMutation({
    mutationFn: () => logout(fetch),
    mutationKey: ['logout']
  });
}
